import { useEffect, useRef, useState } from "react";

const DEFAULT_STICKY_INPUT_OFFSET_PX = 128;

export function useStickyInputOffset(enabled: boolean) {
  const inputFormRef = useRef<HTMLFormElement>(null);
  const [stickyInputOffset, setStickyInputOffset] = useState(
    DEFAULT_STICKY_INPUT_OFFSET_PX
  );

  useEffect(() => {
    if (!enabled) return;

    const form = inputFormRef.current;
    if (!form) return;

    const updateOffset = () => {
      const nextOffset = Math.ceil(form.getBoundingClientRect().height);
      setStickyInputOffset(nextOffset);
    };

    updateOffset();

    if (typeof ResizeObserver === "undefined") return;

    const observer = new ResizeObserver(() => {
      updateOffset();
    });

    observer.observe(form);

    return () => observer.disconnect();
  }, [enabled]);

  return { inputFormRef, stickyInputOffset };
}
